module.exports = __webpack_public_path__ + "static/media/mobile-background-layout-shrink.244bc788.png";